// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__OAiXE","open":"Modal_open__YhPS2","contentWrapper":"Modal_contentWrapper__iVTT9","closeBtn":"Modal_closeBtn__GsxZG"};